import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle } from 'react';

const ChatInput = forwardRef(({ onSendMessage, isLoading, placeholder }, ref) => {
    const [input, setInput] = useState('');
    const textareaRef = useRef(null);

    useImperativeHandle(ref, () => ({
        focus: () => {
            textareaRef.current?.focus();
        },
        blur: () => {
            textareaRef.current?.blur();
        },
        getElement: () => textareaRef.current
    }));

    useEffect(() => {
        const isDesktop = window.innerWidth > 768 &&
            !('ontouchstart' in window) &&
            navigator.maxTouchPoints === 0;



        if (!isLoading && textareaRef.current) {
            if (isDesktop) {

                setTimeout(() => {
                    if (textareaRef.current) {

                        textareaRef.current.focus();

                    } else {

                    }
                }, 100);
            } else {

            }
        }
    }, [isLoading]);

    const adjustHeight = (textarea) => {
        if (!textarea) return;

        textarea.style.height = '48px';

        const scrollHeight = textarea.scrollHeight;
        const maxHeight = 120;

        if (scrollHeight > 48) {
            textarea.style.height = Math.min(scrollHeight, maxHeight) + 'px';
        }
    };

    const handleInput = (e) => {
        setInput(e.target.value);
        adjustHeight(e.target);
    };

    const handleSend = () => {
        if (input.trim()) {

            onSendMessage(input);
            setInput('');

            setTimeout(() => {
                if (textareaRef.current) {
                    textareaRef.current.style.height = '48px';
                }
            }, 0);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey && !isLoading && input.trim()) {
            e.preventDefault();
            handleSend();
        }
    };

    // 🔴 Handlers para debugging
    const handleFocus = () => {

    };

    const handleBlur = () => {
        setTimeout(() => {            
            window.scrollTo(0, window.scrollY);
        }, 100);
    };

    return (
        <div className="input-container">
            <div className="input-wrapper">
                <textarea
                    ref={textareaRef}
                    id="messageInput"
                    disabled={isLoading}
                    placeholder={placeholder}
                    value={input}
                    onChange={handleInput}
                    onKeyDown={handleKeyPress}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    rows={1}
                />
                <button
                    id="sendButton"
                    onClick={handleSend}
                    disabled={isLoading || !input.trim()}
                    title="Send message (Enter)"
                >
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M12 19V5M5 12l7-7 7 7" />
                    </svg>
                </button>
            </div>
        </div>
    );
});

ChatInput.displayName = 'ChatInput';

export default ChatInput;